import util from './util';

export function loadLogLevelAndInitializeApm() {
  const authToken = localStorage.getItem('access_token');
  if (!authToken) {
    return;
  }

  // -1: disabled, 1: detailed, anything else: errors only.
  const rumLogLevel = localStorage.getItem('rum_log_level');
  if (rumLogLevel === '-1') {
    return;
  }
  const isDetailed = rumLogLevel === '1';

  import('@/Utils/apm').then(({ initializeApm }) => {
    initializeApm({
      authToken,
      serverUrl: util.isDevMode ? 'http://localhost:8200' : 'https://apm.gogograndparent.com',
      gogoApiOrigin: new URL(import.meta.env.VITE_API_URL!).origin,
      env: import.meta.env.NODE_ENV!,
      isDetailed,
      userId: localStorage.getItem('operatorId') ?? undefined,
    });
  });
}
